// Rails verifies X-CSRF-Token on every non-GET request, JSON included (#1658).
// Read the meta tag at call time rather than caching it: sign-in rotates the token.
export const csrfToken = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '';

export const csrfHeaders = (): Record<string, string> => ({ 'X-CSRF-Token': csrfToken() });

// Inertia's axios only sends X-XSRF-TOKEN from an XSRF-TOKEN cookie, which Rails
// never sets, so router.post/put/patch/delete and useForm went out with no token
// and Rails answered 422 (#1997). Wired to router.on('before') in inertia.ts;
// headers the caller passed still win.
export const addCsrfHeaderToVisit = (visit: { method: string; headers: Record<string, string> }) => {
  if (visit.method.toLowerCase() === 'get') return;
  visit.headers = { ...csrfHeaders(), ...visit.headers };
};
